import type { Entrega, ProximaEntrega } from '../types/pedido'

export const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']

export function plata(n: number): string {
  return '$' + Math.round(n).toLocaleString('es-AR')
}

export function telLindo(whatsapp: string): string {
  return whatsapp.replace(/^549?/, '').replace(/^(\d{2})(\d{4})(\d{4})$/, '$1 $2-$3')
}

/**
 * De la lista de días de reparto de un barrio, devuelve la fecha más próxima.
 * Si hoy es día de reparto pero ya pasó la hora de corte, salta a la próxima vuelta.
 */
export function proximaEntrega(entregas: Entrega[], horaCorte: number, ahora = new Date()): ProximaEntrega | null {
  if (!entregas.length) return null

  const candidatas = entregas.map((en) => {
    let delta = (en.dia - ahora.getDay() + 7) % 7
    if (delta === 0 && ahora.getHours() >= horaCorte) delta = 7
    return { ...en, delta }
  })

  const elegida = candidatas.reduce((a, b) => (b.delta < a.delta ? b : a))
  const fecha = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate() + elegida.delta)

  return {
    fecha,
    dia: elegida.dia,
    ruta: elegida.ruta,
    esHoy: elegida.delta === 0,
    esManana: elegida.delta === 1,
    txt: fecha.toLocaleDateString('es-AR', { day: 'numeric', month: 'long' }),
  }
}

/** "hoy mismo" / "mañana" / "el jueves 14 de marzo" */
export function cuandoLlega(entrega: ProximaEntrega | null): string {
  if (!entrega) return 'cuando confirmemos el día de tu zona'
  if (entrega.esHoy) return 'hoy mismo'
  if (entrega.esManana) return 'mañana'
  return `el ${DIAS[entrega.dia]} ${entrega.txt}`
}
